export interface IModuleInfo {
    AtividadeNo: number;
    ProcessoNo: number;
    UsuarioLogadoNo: number;
    userName: string;
    baseUrl: string;
    isCustom?: boolean;
}
